import { FmApi } from '.'

import { User, UserGuildRole } from '~/shared/types/services/user'

export const UserApi = FmApi.injectEndpoints({
  endpoints: (build) => ({
    // TODO(sweetliquid): 等 v2 的 user/info 接口出来之后会附带角色信息，这里就没必要额外调用接口了
    getUserGuildRole: build.query<UserGuildRole, void>({
      query: () => '/v2/guild/role',
    }),
    getUserInfo: build.query<User, void>({
      query: () => '/user/info',
    }),
  }),
}).endpoints
